
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRank4 as ObiRank4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-rank-4.js';
 
 
 

 
 export const ObiRank4 = createComponent({
   react: React,
   tagName: 'obi-rank-4',
   elementClass: ObiRank4Element,
   events: {
     
   }
  });
 
 